<template>
    <div>
    <!-- <ul class="ul_div">
        <li class="li_li"></li>
        <li>充值总金额：<span>{{form.totalAmount}}</span></li>
        <li>包月充值总金额：<span>{{form.qrcodeAmount}}</span></li>
        <li>扫码充值总金额：<span>{{form.userQrcode}}</span></li>
    </ul> -->
        <!-- <el-radio-group v-model="isCollapse" style="margin-bottom:20px" >
          <el-radio-button label="basic">扫码订单</el-radio-button>
          <el-radio-button label="coupon">包月订单</el-radio-button> -->
          <!-- <el-radio-button label="mobile">手机端订单</el-radio-button> -->
        <!-- </el-radio-group> -->
        <div :is="isCollapse"></div>
    </div>
</template>
<script>
import * as sysApi from "../../common/sys";
import basic from "./orderDetail1";
import coupon from "./orderDetail2";
// import mobile from "./orderDetail3";
export default {
    data() {
        return {
            isCollapse: 'basic',
            currentView: 'basic',
            form:{
                totalAmount:'',
                qrcodeAmount:'',
                userQrcode:''
            }
        }
    },
    components: {
        basic,
        coupon,
       // mobile
    },
    methods: {
       
    },
    created(){
//         sysApi.accountAll().then(data=>{
//             this.form.qrcodeAmount=data.data.amount  
// this.form.userQrcode=data.data.qmount  
// this.form.totalAmount=data.data.summount 
//             console.log(data);
//         })
//          .catch(err => console.log(' :' + err));
    }
}
</script>
<style lang="scss">
.ul_div{
    overflow: hidden;
    width:100%!important;
    /* position:fixed;
    bottom:20px; */
    border-top:1px solid #333;
    border-bottom:1px solid #333;
    border-right:1px solid #333;
    margin-bottom: 15px;
    height: 50px;
    /* background: #fff !important; */
}
.ul_div li{
    float: left;
    margin-right: 50px;
    line-height: 50px;
    list-style: none;color: #333;
}
.ul_div li.li_li{
    width:5px;
    background: #409EFF;
    height: 50px;
    margin-right:10px;
}
.el-radio-button {
    .el-radio-button__inner {
        width: 120px;
        border: none;
        border-radius: 0;
    }
}
.el-input__inner{
    margin-bottom:0;
}
</style>



